<template>
  <div >
      <div  class = "map" >
        <l-map 
        :zoom="zoom" 
        :center="center"
        @click="addMarker" 
        >
   
          <l-marker
              v-for="(marker, index) in AllApplication"
              :key="index"
               @click="popup(marker.appname, marker.app_key)"
              
              :lat-lng="latLng(marker.latitude, marker.longitude)"
              
            >
                <l-icon 
              :icon-size="iconSize"
              :icon-url ="icon">  
              </l-icon>
              <l-popup  
                         
              :content=" 
              `<div> 
                 <div class='text-center'>
                    <h5> Lokasi Pengamatan </h5>
                    <h5>${marker.appname}</h5>
                    <h5> Ketinggian air ${level} meter</h5>
   
                    <h5>  <a class='text-dark' href='/sensor/${marker.appname}'>klik disini untuk detail</a>
                   
                  </div>
                </div>`
              "/>
            </l-marker> 
         <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
          <l-control-scale position="topright" :imperial="false" :metric="true"></l-control-scale>
            </l-map>
      </div>
  </div>
</template>



<script>
// export default {
// import { Icon } from 'leaflet';  

import L from 'leaflet';
import markerIcon from '../../assets/img/marker2.png' 

import {LMap, LIcon, LTileLayer, LControlScale, LMarker, LPopup} from 'vue2-leaflet';
// import {LMap, LTileLayer, LControlScale, LMarker} from 'vue2-leaflet';

// see here https://codesandbox.io/s/zrp7o89op3?file=/src/components/MyMap.vue
// http://jsfiddle.net/f7dksf2m/2/
// https://github.com/vue-leaflet/Vue2Leaflet#how-can-i-bind-events-of-vue2leaflet-components-
// https://stackoverflow.com/questions/58240998/how-to-add-vue-router-link-inside-of-leaflet-marker-popup
// https://regenrek.com/posts/how-to-build-a-breakfast-restaurant-locator-with-nuxtjs-and-algolia-search/
// https://github.com/vue-leaflet/Vue2Leaflet/issues/35

export default {
  components: {
    LMap,
    LTileLayer,
    LControlScale,
    LMarker,
    LPopup,
    LIcon
  },
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 11,
      center: this.currentCenter || [	0.1342032,117.4838224],
      attribution:'&copy Map  ',
      markerObjects: null,
      icon:markerIcon,
      iconSize:[30,50],
      // level:''
    
    };
  },
    computed: {
        AllApplication() {
            return this.$store.state.AllApplication
        },

        level: {
          get() {
            return this.$store.state.Level
          },
          set(value) {
            this.$store.commit('set_Level', value)
          }
        }
    },

    methods: {

      latLng: function(lat,lng) {
        return L.latLng(lat,lng)
      },

      addMarker(event) {
        // this.markers.push(event.latlng.lat);
        this.$store.commit('set_latitude', event.latlng.lat)
        this.$store.commit('set_longitude', event.latlng.lng)
        // console.log(event.latlng.lat)
        this.markers = [event.latlng.lat,event.latlng.lng]
        this.currentCenter = [this.$store.getters.latitude,this.$store.getters.longitude]
        // this.zoom = "18" 
      },

      popup(appname){
        this.$store.dispatch('SearchUpdate', appname)
        this.$store.dispatch('getChartdata', appname)
        this.$store.dispatch('getApplicationDetailPublic', appname)
        

      }

    }



}

</script>

<style>
.leaflet-popup-content-wrapper, .leaflet-popup-tip {
    background: orange;
    color: rgb(247, 247, 247);
    box-shadow: 0 3px 14px rgba(0,0,0,0.4);
}

.map {
  height: 80vh; 
  width: 100%;
}

@media only screen and (max-width: 600px) {
  /* For mobile: */
  .map {
  height: 40vh; 
  width: 100%;
}
}
</style>